<template>
  <router-view></router-view>
  <CToaster
    v-for="p in placements"
    :key="p"
    :placement="p"
    class="c-toaster-fixed"
  >
    <CToast
      v-for="t in toaster.state.items.filter(x => x.placement === p)"
      :key="t.id"
      :visible="true"
      :autohide="t.autohide"
      :delay="t.delay"
      :class="t.classes"
      @close="toaster.remove(t.id)"
    >
      <!-- เปิด header ได้ตามต้องการ -->
      <!--
      <CToastHeader v-if="t.title || t.icon">
        <CIcon v-if="t.icon" :icon="t.icon" class="me-2" />
        <strong class="me-auto">{{ t.title }}</strong>
      </CToastHeader>
      -->
      <CToastBody>{{ t.text }}</CToastBody>
    </CToast>
  </CToaster>

</template>

<script>
import toaster from '@/plugins/toaster'
export default {
  setup() {
    const placements = [
      'top-start','top-center','top-end',
      'middle-start','middle-center','middle-end',
      'bottom-start','bottom-center','bottom-end',
    ]
    return { toaster, placements }
  },
  name: 'App',
}
</script>

<style lang="scss">
.c-toaster-fixed { z-index: 12000; }
// Import Main styles for this application
// @import 'assets/scss/style';
</style>